declare var window: any;

var ListHelper = {
    sort: function (array: any[], sortField: string) {
        return array.sort(function (a, b) {
            return a[sortField].localeCompare(b[sortField]);
        });
    }
}

export default ListHelper;